import { z } from "zod";

import { sanitizePersonNameInput } from "../../utils/personNameInput";

const INVALID_PERSON_NAME_CHARS_MESSAGE =
  "Use only letters, spaces, hyphens, apostrophes, or periods in this field.";

export const formattedName = (errmsg?: string) =>
  z
    .string()
    .min(1, errmsg || "Value must have a minimum of 1 character")
    .refine((val) => sanitizePersonNameInput(val) === val, {
      message: INVALID_PERSON_NAME_CHARS_MESSAGE,
    })
    .transform((val) => val.charAt(0).toUpperCase() + val.slice(1));
